import React from "react";

const HamburgerSearch = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.3008 13.5391V15.3008H0V13.5391H11.3008ZM14.0508 0C15.6152 9.37041e-05 16.9402 0.561349 18.0449 1.69434C19.1501 2.82782 19.7002 4.1918 19.7002 5.80469C19.7002 6.36554 19.6199 6.92214 19.459 7.47559C19.2993 8.02476 19.0605 8.5294 18.7422 8.99023L18.5791 9.22656L18.7803 9.43359L23.1602 13.9268L21.9697 15.1484L17.6006 10.668L17.3896 10.4512L17.1445 10.6289C16.6961 10.9547 16.2059 11.1992 15.6729 11.3623C15.1353 11.5267 14.5949 11.6084 14.0508 11.6084C12.4862 11.6084 11.1605 11.0472 10.0557 9.91406C8.95062 8.78068 8.40049 7.41738 8.40039 5.80469C8.40039 4.1918 8.95052 2.82782 10.0557 1.69434C11.1605 0.561189 12.4862 0 14.0508 0ZM14.0508 1.76172C12.9562 1.76172 12.0156 2.15916 11.25 2.94434C10.4847 3.7293 10.1006 4.69008 10.1006 5.80469C10.1007 6.9191 10.4848 7.87921 11.25 8.66406C12.0156 9.44926 12.9562 9.84668 14.0508 9.84668C15.1451 9.84659 16.0851 9.4491 16.8506 8.66406C17.6158 7.87921 17.9999 6.9191 18 5.80469C18 4.69008 17.6159 3.7293 16.8506 2.94434C16.0851 2.15932 15.1451 1.76181 14.0508 1.76172ZM5.30078 7.38477V9.14648H0V7.38477H5.30078ZM5.30078 1.23145V2.99316H0V1.23145H5.30078Z"
      fill={color}
    />
  </svg>
);

HamburgerSearch.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};

export default HamburgerSearch;
